// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__162Cq","header":"PatientBlock_header__2zT4B","label":"PatientBlock_label__2_hvP","option":"PatientBlock_option__3rq5o"};